import { InputField, Grid, FormComponentProps, ImageUpload } from '@/components';
import { useFormContext } from 'react-hook-form';

const inputs = [
  { name: 'type', label: 'Type', required: true },
  { name: 'fileName', label: 'FileName', required: true },
];

export const formBasicFields = [...inputs];

export const FormBasic = ({ disabled, values, t }: FormComponentProps) => {
  const { setValue } = useFormContext();

  return (
    <Grid container>
      {inputs.map(({ ...field }) => (
        <Grid key={field.name} {...{ item: true, xs: 12, sm: 6 }}>
          <InputField {...{ ...field, label: t(field.label), disabled }} />
        </Grid>
      ))}
      <Grid {...{ item: true, xs: 12 }}>
        <ImageUpload
          value={values.fileData}
          type={values.fileType}
          onChange={(data, name, type) => {
            setValue('fileData', data, { shouldDirty: true, shouldValidate: true });
            setValue('fileName', name, { shouldDirty: true, shouldValidate: true });
            setValue('fileType', type, { shouldDirty: true, shouldValidate: true });
          }}
        />
      </Grid>
    </Grid>
  );
};
